import { createSlice } from '@reduxjs/toolkit';
import reducers from 'src/redux/vendor-portal/onboarding/reducers';
import extraReducers from './extra-reducers';
import {
  ONBOARDING_STEPS,
  type OnboardingStateType,
  type ServiceAreaDataType,
  type ServiceOfferedDataType,
} from './types';

const onboardingInitialState: OnboardingStateType = {
  basicInfo: {
    address1: '',
    address2: '',
    city: '',
    company: '',
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    service: '',
    vendorId: '',
    zip: '',
    isSynced: false,
  },
  isLoading: true,
  onboardingId: '',
  serviceArea: {} as ServiceAreaDataType,
  serviceOffered: {} as ServiceOfferedDataType,
  type: '',
  step: ONBOARDING_STEPS.INITIAL,
  locationAPIKey: '',
};

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState: onboardingInitialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const { changeStep, setSignedUrl } = onboardingSlice.actions;

export default onboardingSlice.reducer;
